import type { ReactElement } from "react"
import Page from "@Components/Page"
import SectionHeader from "@Components/Section/SectionHeader"
import Section from "@Components/Section/Section"
import { Loader } from "@axdspub/axiom-ui-utilities"
import PageTitle from "@/Components/PageTitle"
import { FEEDBACK_URL } from "@/config"

const Feedback = (): ReactElement => {
    const feedbackURL = FEEDBACK_URL
    if(feedbackURL === undefined) {
        throw new Error("Feedback URL is not defined")
    }
    return (
        <div className='w-[80%] sm:w-[90%] mx-auto'>
            <PageTitle>Feedback</PageTitle>
            <Page>

                <Section shaded={false}>
                    <SectionHeader className='text-4xl'>Feedback</SectionHeader>
                    <p className='text-sm'>
                        Please let us know if you are experiencing an issue with
                        WebCOOS, or if there are improvements you would like to see.

                        We look forward to your feedback.
                    </p>
                    <div className='relative max-w-128 -mx-[35px]'>
                    <Loader className='mx-auto h-8 w-8 absolute top-16 left-1/2' />

                    <iframe
                        className='w-full h-128 absolute top-0'
                        src={feedbackURL}
                    ></iframe>
                    </div>
                </Section>
            </Page>
        </div>
    )
}

export default Feedback